import { request } from '@/utils/request'

export class ProxyCompensationConfiguration {
    constructor() {
        this.__loading = 0
        this.__categories = []
    }

    get loading() {
        return this.__loading > 0
    }

    get categories() {
        if (this.__categories.length === 0) {
            this.__loadConfiguration()
        }

        return this.__categories
    }

    async __loadConfiguration() {
        if (this.__loading > 0) {
            return
        }

        this.__loading += 1
        try {
            this.__apply(await request.get('/api/providers/sec/proxy-compensation/configuration'))
        } catch {
            // yuck
        }
        this.__loading -= 1
    }

    __apply(content) {
        if (content.categories) {
            this.__categories = content.categories.sort((lhs, rhs) => lhs.localeCompare(rhs))
        }
    }
}
